import AxiosManager from "../../../util/axiosLib/axiosManager";
import apiManager from "../../../utilNew/apiManager";


var apiUrl=process.env.VUE_APP_apiUrl +"/";
// var apiUrl="http://127.0.0.1:8000/";
// var apiUrl= "https://kianseng.org/"
// var apiPathBase="api/test/";
var apiPathBase="api/admin/";





export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        return new apiManager(apiUrl,apiPathBase,"",this.getAxiosManager(),null)
    },

    // api_Test ( data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_CallMethod_ByParamObj("testPost",data)
    // },
    // api_Upload (file, data)
    // {
    //     debugger // eslint-disable-line
    //     // return this.getApiManager().api_CallMethod_SendObj("testPost",data)
    //     return this.getApiManager().api_UpdateFile("upload",file,data)
    // },

    //---------------------------------------


    api_saveContent ($queryType, jsonData)
    {
        // debugger // eslint-disable-line
        let data={
            queryType:$queryType,
            data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("saveContent",data)
    },




    api_getContent ( $queryType)
    {
        let data={
            queryType:$queryType,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getContent",data)
    },

    api_saveContentBySystemId ($queryType,$systemId, jsonData)
    {
        // debugger // eslint-disable-line
        let data={
            queryType:$queryType ,
            SystemId:$systemId ,
            data01:JSON.stringify(jsonData),
        }

        return this.getApiManager().api_CallMethod_ByParamObj("saveContentBySystemId",data)
    },

    api_getContentBySystemId ( $systemId)
    {
        // debugger // eslint-disable-line
        let data={
            SystemId: $systemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getContentBySystemId",data)
    },

    api_deleteContentBySystemIds ( $systemIds){
        let data={
            SystemIds: $systemIds,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("deleteContentBySystemIds",data)

    },
    api_deleteContentBySystemId ( $systemId)
    {
        // debugger // eslint-disable-line
        let data={
            SystemId: $systemId,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("deleteContentBySystemId",data)
    },

    getContentList ( $queryType)
    {
        // debugger // eslint-disable-line
        let data={
            queryType:$queryType ,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getContentList",data)
    },

    //---------------


    api_saveSetting ($queryType, settingValue)
    {
        // debugger // eslint-disable-line
        let data={
            queryType:$queryType,
            data01:settingValue,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("saveSetting",data)
    },

    api_getSetting ( $queryType)
    {
        // debugger // eslint-disable-line
        let data={
            queryType:$queryType,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getSetting",data)
    },

    api_yearArchive ()
    {
        // debugger // eslint-disable-line
        let data={
        }

        return this.getApiManager().api_CallMethod_ByParamObj("yearArchive",data)
    },
    //---------------
    api_upload (file, data)
    {
        return this.getApiManager().api_UpdateFile("upload",file,data)
    },
    api_uploadWaitProcess (file)
    {
        return this.getApiManager().api_UpdateFile("uploadWaitProcess",file,{})
    },
    api_uploadToStorage (file, data)
    {
        return this.getApiManager().api_UpdateFile("uploadToStorage",file,data)
    },
    api_Admin_ChangePwd (pwdCurrent,pwdNew)
    {
        let data={
            pwdCurrent:pwdCurrent,
            pwdNew:pwdNew
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ChangePwd",data)
    },
    init($jsonStr){
        if ($jsonStr===""){
            return [];
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnString($jsonStr){
        if ($jsonStr===""){
            return "";
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnObject($jsonStr){
        if ($jsonStr===""){
            return {};
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnObjectWithTemplate($jsonStr,template){
        if ($jsonStr===""){
            return {...template};
        }else{
            return JSON.parse($jsonStr);
        }
    },
    initReturnArray(arrWork){

        return arrWork;
        // var arrResult = arrWork.map(function(item, index, array){
        //     return JSON.parse(item);
        // });

        // return arrResult;
    },

    api_Admin_Question_Query ()
    {
        let data={
            "a":"xx"
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getQuestion",data)
    },

    api_getContent2 ( $queryType)
    {
        let data={
            queryType:$queryType,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("getContent2",data)
    },
}
